import { Component, ErrorInfo, ReactNode } from 'react';

const RELOAD_FLAG_KEY = 'chunkErrorReloadedAt';
const RELOAD_COOLDOWN_MS = 15_000;

const isChunkLoadError = (error: Error): boolean =>
  /loading chunk .* failed|failed to fetch dynamically imported module|chunkloaderror/i.test(
    `${error?.name} ${error?.message}`
  );

type Props = { children: ReactNode };
type State = { hasError: boolean };

export class ChunkErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    if (isChunkLoadError(error)) {
      const lastReloadAt = Number(sessionStorage.getItem(RELOAD_FLAG_KEY) ?? 0);
      const withinCooldown = Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS;

      if (!withinCooldown) {
        sessionStorage.setItem(RELOAD_FLAG_KEY, String(Date.now()));
        window.location.reload();
        return;
      }
    }

    console.error('Unhandled render error', error, info);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
